import Vue from 'vue'
import VueRouter from 'vue-router'
import translation from '@/services/translation'
import auth from '@/services/auth'
import i18n from '@/plugins/i18n'
import local from '@/local'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/:language',
      component: () => import(/* webpackChunkName: "router" */ '@/views/Router.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'login',
          name: 'login',
          component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'login/:token',
          name: 'login_as',
          component: () => import(/* webpackChunkName: "login_as" */ '@/views/LoginAs.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'forgot',
          name: 'forgot',
          component: () => import(/* webpackChunkName: "forgot" */ '@/views/Forgot.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'reset/:token',
          name: 'reset',
          component: () => import(/* webpackChunkName: "reset" */ '@/views/Reset.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'app',
          name: 'app',
          component: () => import(/* webpackChunkName: "app_" */ '@/views/App.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'oauth2',
          name: 'oauth2_home',
          component: () => import(/* webpackChunkName: "oauth2_home" */ '@/views/OAuth2Home.vue'),
          meta: {
            language: true,
            public: true
          }
        },
        {
          path: 'events',
          name: 'events',
          component: () => import(/* webpackChunkName: "events" */ '@/views/Events.vue'),
          meta: {
            language: true
          }
        },
        {
          path: 'studio/:event_id',
          name: 'studio',
          component: () => import(/* webpackChunkName: "studio" */ '@/views/Studio.vue'),
          meta: {
            language: true
          }
        },
        {
          path: 'done/:event_id',
          name: 'done',
          component: () => import(/* webpackChunkName: "done" */ '@/views/Done.vue'),
          meta: {
            language: true
          }
        },
        {
          path: 'files/:event_id',
          name: 'files',
          component: () => import(/* webpackChunkName: "files" */ '@/views/Files.vue'),
          meta: {
            language: true
          }
        },
        {
          path: 'catcher',
          name: 'catcher',
          component: () => import(/* webpackChunkName: "catcher" */ '@/views/Catcher.vue'),
          meta: {
            language: true,
            public: true
          }
        }
      ]
    },
    {
      path: '/deeplink/:deeplink_uuid',
      name: 'deeplink',
      component: () => import(/* webpackChunkName: "deeplink" */ '@/views/Deeplink.vue'),
      meta: {
        public: true
      }
    },
    {
      path: '/oauth2/:provider/finish',
      name: 'oauth2_finish',
      component: () => import(/* webpackChunkName: "oauth2_finish" */ '@/views/OAuth2Finish.vue'),
      meta: {
        public: true
      }
    },
    {
      path: '/test/browser/:test_id',
      name: 'test-browser',
      component: () => import(/* webpackChunkName: "test_browser" */ '@/views/TestBrowser.vue'),
      meta: {
        public: true
      }
    },
    {
      path: '*',
      redirect (to) {
        return translation.route({ name: 'home' }, translation.userLanguage())
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Process language
  const l = to.params.language
  if (!translation.isSupportedLanguage(l)) {
    translation.currentLanguage = translation.userLanguage()
    const hl = to.matched.some(record => record.meta.language)
    if (hl) {
      return next(translation.route({
        name: 'home'
      }))
    }
  }
  translation.changeLanguage(l)

  // Update document title
  const k = 'pages.' + to.name + '.document'
  const t = i18n.t(k)
  let v = ''
  if (local.machine_env === 'staging' || local.machine_env === 'local') v = '[' + local.machine_env + '] '
  v += t === k ? 'narative' : t
  document.title = v

  // Get auth attributes
  const p = to.matched.some(record => record.meta.public)
  const lg = auth.logged()

  // User should login
  if (!p && !lg) return next(auth.forcedLogoutRoute(to.fullPath))

  // TODO Remove
  // Logout users who were logged before reset
  if (!p && lg && auth.user && (typeof auth.user.registration_completed !== 'undefined' || typeof auth.user.avatar_url === 'undefined')) return next(auth.forcedLogoutRoute(to.fullPath))

  // Next
  next()
})

export default router
